import { shade } from 'polished'
import { Link } from 'react-router-dom'
import { Nav } from 'reactstrap'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  align-self: stretch;
  @media ${queries.less.sm} {
    gap: 16px;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;

  @media ${queries.less.xl} {
    flex-direction: column;
    gap: 10px;
  }
`

export const ButtonTemplate = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: #776cf1;
  border-radius: 16px;
  padding: 10px 20px;
  text-decoration: none;
  height: auto;
  flex-grow: initial;
  align-items: center;
  display: flex;
  max-height: 34px;
  transition-duration: 0.2s;
  max-width: 200px;

  &:hover {
    background-color: ${shade(0.2, '#776cf1')};
    color: white;
  }

  svg {
    margin-right: 12px;
  }

  @media ${queries.less.sm} {
    width: 100%;
    justify-content: center;
    max-width: 100%;
  }
`

export const FiltersAndSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;

  @media ${queries.less.sm} {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  h1 {
    color: #767676;
    font-size: 1.5rem;
    font-weight: 600;
  }

  input {
    min-width: 300px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 0.875rem 0.875rem 0.875rem 3rem;

    &:focus-visible {
      outline: #a6a4a4 auto 2px;
    }
  }

  button {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 1rem;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    background-color: #fff;
    color: #2d3748;
    gap: 0.625rem;

    &:focus-visible {
      outline: #a6a4a4 auto 2px;
    }

    &:focus {
      outline: #a6a4a4 auto 2px;
    }

    &.view-button[data-active='true'] {
      border: none;
      background-color: #6f64f8;
      color: #fff;
    }

    &.filter-button[data-active='true'] {
      background-color: #f9f9f9;
    }

    &.filter-button {
      small {
        width: 20px;
        height: 20px;
        background: #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }
    }

    &:disabled {
      background-color: #f7fafc;
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .input-search {
    position: relative;
    display: flex;
    justify-content: start;
    align-items: center;

    .search-icon {
      position: absolute;
      left: 1rem;
    }

    @media ${queries.less.sm} {
      display: none;
    }
  }
`

export const MobileSearchContainer = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  flex: 1;
  border: 1px;

  .input-search {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: start;
    align-items: center;

    .search-icon {
      position: absolute;
      left: 1rem;
    }
  }

  input {
    width: 100%;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 0.875rem 0.875rem 0.875rem 3rem;

    &:focus-visible {
      outline: #a6a4a4 auto 2px;
    }
  }

  @media ${queries.less.sm} {
    display: flex;
  }
`

export const StyledNav = styled(Nav)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2em;
  align-items: end;
  border-bottom: 1px solid rgba(196, 196, 196, 0.2) !important;
  padding: 0;
  box-shadow: none !important;
  overflow-x: auto;
  overflow-y: hidden;

  @media ${queries.less.sm} {
    width: 100%;
    gap: 0;
    justify-content: start;
    align-items: start !important;
  }

  > li {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: auto;
    height: 100%;
    font-size: 1rem;
    padding: 1em 2em 0.5em 2em;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    .nav-link {
      color: #d2d2ff !important;
    }

    @media ${queries.less.sm} {
      padding: 1em 1em 0.5em 1em;
    }
  }

  > li.active {
    color: #556ee6 !important;
    border-bottom: 3px solid #556ee6;
  }
`

export const TabsAndSortWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  @media ${queries.less.sm} {
    flex-direction: column;
    align-items: start;
    gap: 1rem;
  }

  .reviews-tab {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    @media ${queries.less.sm} {
      width: 100%;
    }

    &[data-disabled='true'] {
      cursor: not-allowed;
      & li {
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }

  .count-text {
    color: #2f2b3de5;
    font-size: 0.875rem;
    font-weight: 600;

    // @media ${queries.less.sm} {
    //   display: none;
    // }
  }

  .filter-select {
    width: 235px;
  }
`

export const ListingBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 0.5rem;
  align-self: stretch;

  .dropdown-toggle {
    border: 1px solid #c4c4c4;
    background-color: #fff !important;
    color: #2c2c2c;

    &:focus {
      color: #2c2c2c !important;
    }

    &:focus-visible {
      color: #2c2c2c !important;
    }

    &:hover {
      color: #2c2c2c !important;
    }
  }

  .dropdown-item {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .review-pagination {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;

    @media ${queries.less.sm} {
      flex-direction: column;
      gap: 1.5rem;
      margin-bottom: 4.5rem;
    }
  }

  .no-results {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    div:nth-child(1) {
      color: #2f2b3de5;
      font-size: 0.875rem;
      align-self: flex-start;
    }

    div:nth-child(2) {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      color: #161616;
      border-radius: 0.5rem;
      border: 1px solid #e2e8f0;
      padding: 1rem;
    }
  }

  .loading-shimer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    .shimer-card {
      width: 100%;
      height: 10rem;
      background-color: #f7fafc;
      border-radius: 0.5rem;
      animation: skeleton-loading 1s infinite alternate;
    }

    .shimer-pagination {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      @media ${queries.less.sm} {
        flex-direction: column-reverse;
        gap: 1rem;
      }

      div {
        height: 2.5rem;
        background-color: #f7fafc;
        border-radius: 0.5rem;
        animation: skeleton-loading 1s infinite alternate;

        &:nth-child(1) {
          width: 7rem;
        }

        &:nth-child(2) {
          width: 14rem;
        }
      }
    }

    @keyframes skeleton-loading {
      0% {
        background-color: hsl(200, 20%, 80%);
      }
      100% {
        background-color: hsl(200, 20%, 95%);
      }
    }
  }
`
export const CustomPagination = styled.div`
  width: 80%;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;

  @media ${queries.less.sm} {
    width: 100%;
    justify-content: center;
  }

  button {
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    border: none;
    background-color: #ededed;
    border-radius: 999999px;
    aspect-ratio: 1/1;

    &:hover {
      background-color: #b3b1b1;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
    }

    &[data-active='true'] {
      background-color: #6f64f8;
      color: #fff;
    }

    &:disabled {
      background-color: #f7fafc;
      cursor: not-allowed;
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ededed;
    border-radius: 999999px;
  }
`

export const ActiveNPSWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
  @media ${queries.more.sm} {
    padding: 44px;
  }
  @media ${queries.less.sm} {
    margin-bottom: 5rem !important;
  }

  .result {
    display: flex;
    padding: 0px var(--Components-Result-Global-paddingXL, 32px);
    flex-direction: column;
    align-items: center;
    gap: var(--Components-Result-Global-paddingLG, 24px);
    align-self: stretch;
    @media ${queries.more.sm} {
      gap: 40px;
    }
    img {
      width: var(--Components-Result-Component-iconFontSize, 72px);
      height: var(--Components-Result-Component-iconFontSize, 72px);
    }

    .text__wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--Components-Result-Global-marginXS, 8px);
      align-self: stretch;

      h3 {
        align-self: stretch;
        color: #2c2c2c;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 38px; /* 158.333% */
      }
    }

    button {
      background-color: #776cf1;
      border-radius: 8px;
      padding: 8px 24px;
      align-items: center;
      display: flex;
      height: 44px;
      transition-duration: 0.2s;
      color: white;
      font-size: 16px;
      font-weight: 600;
      border: none;

      &:hover {
        background-color: ${shade(0.2, '#776cf1')};
        color: white;
      }
    }
  }
`
export const NoContentWrapper = styled.div`
  display: flex;
  height: 400px;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;

  svg {
    width: 141.956px;
    height: 117.339px;
    flex-shrink: 0;
  }

  span {
    color: #767676;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`
